import { render, staticRenderFns } from "./ProductsSearch.vue?vue&type=template&id=61bd7889"
import script from "./ProductsSearch.vue?vue&type=script&lang=js"
export * from "./ProductsSearch.vue?vue&type=script&lang=js"
import style0 from "./ProductsSearch.vue?vue&type=style&index=0&id=61bd7889&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports